"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcShortcutBehavior = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var default_behavior_1 = require("../../../common/models/default-behavior");
var bc_shortcut_constants_1 = require("./bc-shortcut-constants");
var BcShortcutBehavior = (function (_super) {
    __extends(BcShortcutBehavior, _super);
    function BcShortcutBehavior() {
        return _super.call(this) || this;
    }
    BcShortcutBehavior.setUpAll = function () {
        var shortcutParentElements = Array.from(document.querySelectorAll(".".concat(bc_shortcut_constants_1.BC_SHORTCUT_GROUP_MULTIPLE)));
        var elements = [];
        for (var _i = 0, shortcutParentElements_1 = shortcutParentElements; _i < shortcutParentElements_1.length; _i++) {
            var shortcutParentElement = shortcutParentElements_1[_i];
            var shortcutInstance = new BcShortcutBehavior();
            shortcutInstance.setElement(shortcutParentElement);
            shortcutInstance.setUp();
            elements.push(shortcutInstance);
        }
        return elements;
    };
    BcShortcutBehavior.prototype._setUp = function () {
        this.alignShortcut();
    };
    BcShortcutBehavior.prototype.alignShortcut = function () {
        var shortcuts = Array.from(this.mySelf.querySelectorAll(common_constants_1.BcCommonConstants.HREF_TAG));
        var sectionFirstRow = document.createElement(common_constants_1.BcCommonConstants.SECTION_TAG);
        var sectionSecondRow = document.createElement(common_constants_1.BcCommonConstants.SECTION_TAG);
        this.mySelf.classList.add("".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-").concat(common_constants_1.BcCommonConstants.FLEX), bc_shortcut_constants_1.BC_SHORTCUT_DIRECTION_COLUMN);
        sectionFirstRow.classList.add(bc_shortcut_constants_1.BC_SHORTCUT_ROW, "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-").concat(common_constants_1.BcCommonConstants.FLEX));
        sectionSecondRow.classList.add(bc_shortcut_constants_1.BC_SHORTCUT_ROW, "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-").concat(common_constants_1.BcCommonConstants.FLEX));
        if (shortcuts.length > common_constants_1.COMMON_CONSTANTS_NUMBERS.N4) {
            var mod = shortcuts.length % common_constants_1.COMMON_CONSTANTS_NUMBERS.N2;
            var splitshortcuts = Math.trunc(shortcuts.length / common_constants_1.COMMON_CONSTANTS_NUMBERS.N2);
            var firstRowShortcut = shortcuts.slice(0, (splitshortcuts + mod));
            var secondRowShortcut = shortcuts.slice(splitshortcuts + mod);
            firstRowShortcut.forEach(function (shorcut) {
                sectionFirstRow.appendChild(shorcut);
            });
            secondRowShortcut.forEach(function (shorcut) {
                sectionSecondRow.appendChild(shorcut);
            });
            this.mySelf.appendChild(sectionFirstRow);
            this.mySelf.appendChild(sectionSecondRow);
        }
        else {
            shortcuts.forEach(function (shorcut) {
                sectionFirstRow.appendChild(shorcut);
            });
            this.mySelf.appendChild(sectionFirstRow);
        }
    };
    return BcShortcutBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcShortcutBehavior = BcShortcutBehavior;
